export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(to right, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.85) 50%, rgba(255, 255, 255, 0.3) 100%), url('https://public.readdy.ai/ai/img_res/2da05614fcdc12645b5e9b7c7c71ab82.jpg')`
      }}
    >
      <div className="container mx-auto px-6 py-20">
        <div className="max-w-2xl">
          <h1 className="text-6xl font-bold text-gray-900 mb-6 leading-tight">
            Ragdoll Gentle Paws Adoption
          </h1>
          <p className="text-2xl text-gray-700 mb-8 leading-relaxed">
            Purebred Ragdoll Kittens  Raised With Love, Ready for Forever Homes
          </p>
          <div className="flex flex-wrap gap-4">
            <button 
              onClick={() => scrollToSection('available-kittens')}
              className="whitespace-nowrap px-8 py-4 bg-blue-400 text-white rounded-full font-semibold text-lg hover:bg-blue-500 transition-all shadow-lg hover:shadow-xl cursor-pointer"
            >
              View Available Kittens
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="whitespace-nowrap px-8 py-4 bg-white text-blue-400 border-2 border-blue-400 rounded-full font-semibold text-lg hover:bg-blue-50 transition-all shadow-lg hover:shadow-xl cursor-pointer"
            >
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
